import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost, httpPut } from "../../../services/httpService";
import { logError } from "../../../services/logService";
import {
  getCompanyDetailsUrl,
  getPharmacyServiceAvailibilityUrl,
  getServiceBookingSlotsUrl,
  createSessionUrl,
  createPaymentAuditUrl,
  getAllServicesByCompanyIdUrl,
  getPharmacyByServiceUrl,
  getCompanyMarketAppAccountIdByCompanyId,
  getPatitentConsultationByConsultationIdUrl,
  getPaymentViaLinkDetailsUrl,
} from "../../../apiUrls/apiUrls";

const initialState = {
  isBookingLoading: false,
  isBookingSlotLoading: false,
  companyDetails: null,
  serviceAvailibility: null,
  serviceBookingSlots: null,
  selectedBranch: "",
  bookingModel: {
    PharmacyId: "",
    ServiceId: "6569d675a07b6dcf7a42f2b5",
    DOB: "2000-04-07",
    Address: "",
    FirstName: "",
    LastName: "",
    Gender: 0,
    IsGatewayMet: false,
    questionAnswers: [],
    Title: "",
    Email: "",
    PhoneNumber: "",
    Reason: "",
    PaymentTaken: false,
    AppointmentDate: "",
  },
  ryftSessionData: [],
  Countries: [],
  selectedServiceBookingSlot: null,
  companyServices: null,
  selectedPrivateService: "",
  servicePharmacy: null,
  currentCompanyId: "",
  isEnablePrePayment: false,
  payAmount: 0,
  ryftAccountId: null,
  patientConsultation: [],
  paymentViaLinkDetails: [],
};

export const getCompanyDetailsData = createAsyncThunk(
  "getCompanyDetailsData",
  async (params, thunkAPI) => {
    const { companyID, serviceID } = params;
    const respData = await httpGet(getCompanyDetailsUrl(companyID, serviceID));
    return respData;
  }
);

export const getPharmacyServiceAvailibilityData = createAsyncThunk(
  "getPharmacyServiceAvailibilityData",
  async (params, thunkAPI) => {
    const { pharmacyId, serviceID } = params;
    const respData = await httpGet(
      getPharmacyServiceAvailibilityUrl(pharmacyId, serviceID)
    );
    return respData;
  }
);

export const getServiceBookingSlotsData = createAsyncThunk(
  "getServiceBookingSlotsData",
  async (params, thunkAPI) => {
    const { pharmacyId, serviceId, date } = params;
    const respData = await httpGet(
      getServiceBookingSlotsUrl(pharmacyId, serviceId, date)
    );
    return respData;
  }
);

export const createRyftSessionData = createAsyncThunk(
  "createRyftSessionData",
  async (params, thunkAPI) => {
    const { data } = params;
    const respData = await httpPost(createSessionUrl(), data);
    return respData;
  }
);

export const createPaymentAuditData = createAsyncThunk(
  "createPaymentAuditData",
  async (params) => {
    const { data } = params;
    const respData = await httpPost(createPaymentAuditUrl(), data);
    return respData;
  }
);

export const getAllServicesByCompanyIdData = createAsyncThunk(
  "getAllServicesByCompanyIdData",
  async (params, thunkAPI) => {
    const { companyID } = params;
    const respData = await httpGet(getAllServicesByCompanyIdUrl(companyID));
    return respData;
  }
);

export const getPharmacyByServiceData = createAsyncThunk(
  "getPharmacyByServiceData",
  async (params, thunkAPI) => {
    const { companyID, serviceID } = params;
    const respData = await httpGet(getPharmacyByServiceUrl(companyID, serviceID));
    return respData;
  }
);

export const getCompanyMarketAppAccountIdByCompanyIdData = createAsyncThunk(
  "getCompanyMarketAppAccountIdByCompanyId",
  async (params, thunkAPI) => {
    const { companyID } = params;
    const respData = await httpGet(getCompanyMarketAppAccountIdByCompanyId(companyID));
    return respData;
  }
);

export const getPatientConsultationData = createAsyncThunk(
  "getPatientConsultationData",
  async (params, thunkAPI) => {
    const { consultationID } = params;
    const respData = await httpGet(getPatitentConsultationByConsultationIdUrl(consultationID));
    return respData;
  }
);

export const getPaymentViaLinkData = createAsyncThunk(
  "getPaymentViaLinkData",
  async (params, thunkAPI) => {
    const { consultationID } = params;
    const respData = await httpGet(getPaymentViaLinkDetailsUrl(consultationID));
    return respData;
  }
);

export const bookingSlice = createSlice({
  name: "bookingSection",
  initialState,
  reducers: {
    setIsBookingLoading: (state, action) => {
      state.isBookingLoading = action?.payload || false;
    },
    setSelectedServiceBookingSlotData: (state, action) => {
      state.selectedServiceBookingSlot = action?.payload || null;
    },

    setBookingModelData: (state, action) => {
      state.bookingModel = action.payload;
    },

    updateBookingFieldData: (state, action) => {
      const { field, value } = action.payload;
      if (field in state.bookingModel) {
        state.bookingModel[field] = value;
      }
    },

    setBookingModelData: (state, action) => {
      state.bookingModel = action.payload;
    },
    updateBookingFieldData: (state, { payload }) => {
      const { field, value } = payload;
      state.bookingModel[field] = value;
    },
    setSelectedBranchData: (state, action) => {
      state.selectedBranch = action.payload;
    },
    setSelectedPrivateServiceData: (state, action) => {
      state.selectedPrivateService = action.payload || "";
    },
    setCurrentCompanyIdData: (state, action) => {
      state.currentCompanyId = action.payload || "";
    },

    resetOrbitState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanyDetailsData.pending, (state) => {
        state.isBookingLoading = true;
        state.companyDetails = null;
      })
      .addCase(getCompanyDetailsData.fulfilled, (state, action) => {
        state.isBookingLoading = false;
        state.isEnablePrePayment = action?.payload.isEnablePrePayment || false;
        state.payAmount = action?.payload.price || 0;
        state.companyDetails = action?.payload.companyDetails
          ;
      })
      .addCase(getCompanyDetailsData.rejected, (state, action) => {
        logError(action?.error);
        state.isBookingLoading = false;
        state.companyDetails = null;
      })
      .addCase(getPharmacyServiceAvailibilityData.pending, (state) => {
        state.isBookingLoading = true;
        state.serviceAvailibility = null;
      })
      .addCase(
        getPharmacyServiceAvailibilityData.fulfilled,
        (state, action) => {
          state.isBookingLoading = false;
          state.serviceAvailibility = action?.payload;
        }
      )
      .addCase(getPharmacyServiceAvailibilityData.rejected, (state, action) => {
        logError(action?.error);
        state.isBookingLoading = false;
        state.serviceAvailibility = null;
      })
      .addCase(getServiceBookingSlotsData.pending, (state) => {
        state.isBookingLoading = true;
        state.isBookingSlotLoading = true;
        state.serviceBookingSlots = null;
      })
      .addCase(getServiceBookingSlotsData.fulfilled, (state, action) => {
        state.isBookingLoading = false;
        state.isBookingSlotLoading = false;
        state.serviceBookingSlots = action?.payload;
      })
      .addCase(getServiceBookingSlotsData.rejected, (state, action) => {
        logError(action?.error);
        state.isBookingLoading = false;
        state.isBookingSlotLoading = false;
        state.serviceBookingSlots = null;
      })
      .addCase(createRyftSessionData.pending, (state) => {
        state.ryftSessionData = null;
      })
      .addCase(createRyftSessionData.fulfilled, (state, action) => {
        state.ryftSessionData = action?.payload;
      })
      .addCase(createRyftSessionData.rejected, (state, action) => {
        logError(action?.error);
        state.ryftSessionData = null;
      })
      .addCase(createPaymentAuditData.pending, (state) => { })
      .addCase(createPaymentAuditData.fulfilled, (state, action) => { })
      .addCase(createPaymentAuditData.rejected, (state, action) => { })
      .addCase(getAllServicesByCompanyIdData.pending, (state) => {
        state.companyServices = null;
      })
      .addCase(getAllServicesByCompanyIdData.fulfilled, (state, action) => {
        state.companyServices = action?.payload;
      })
      .addCase(getAllServicesByCompanyIdData.rejected, (state, action) => {
        logError(action?.error);
        state.companyServices = null;
      })
      .addCase(getPharmacyByServiceData.pending, (state) => {
        state.servicePharmacy = null;
      })
      .addCase(getPharmacyByServiceData.fulfilled, (state, action) => {
        state.servicePharmacy = action?.payload;
      })
      .addCase(getPharmacyByServiceData.rejected, (state, action) => {
        logError(action?.error);
        state.servicePharmacy = null;
      })
      .addCase(getCompanyMarketAppAccountIdByCompanyIdData.pending, (state) => {
        state.ryftAccountId = null;
      })
      .addCase(getCompanyMarketAppAccountIdByCompanyIdData.fulfilled, (state, action) => {
        state.ryftAccountId = action?.payload;
      })
      .addCase(getCompanyMarketAppAccountIdByCompanyIdData.rejected, (state, action) => {
        logError(action?.error);
        state.ryftAccountId = null;
      })
      .addCase(getPatientConsultationData.pending, (state) => {
        state.patientConsultation = null;
      })
      .addCase(getPatientConsultationData.fulfilled, (state, action) => {
        state.patientConsultation = action?.payload;
      })
      .addCase(getPatientConsultationData.rejected, (state, action) => {
        logError(action?.error);
        state.patientConsultation = null;
      })
      .addCase(getPaymentViaLinkData.pending, (state) => {
        state.paymentViaLinkDetails = null;
      })
      .addCase(getPaymentViaLinkData.fulfilled, (state, action) => {
        state.paymentViaLinkDetails = action?.payload;
      })
      .addCase(getPaymentViaLinkData.rejected, (state, action) => {
        logError(action?.error);
        state.paymentViaLinkDetails = null;
      })
  },
});
// Action creators are generated for each case reducer function
export const {
  setIsBookingLoading,
  setBookingModelData,
  updateBookingFieldData,
  setSelectedServiceBookingSlotData,
  setSelectedBranchData,
  setSelectedPrivateServiceData,
  setCurrentCompanyIdData,
} = bookingSlice.actions;
export default bookingSlice.reducer;
